import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "suggestion-quarantine" };
const _hoisted_2 = { class: "suggestion-quarantine__title" };
const _hoisted_3 = { class: "required" };
const _hoisted_4 = { class: "suggestion-quarantine__text" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    key: 0,
    class: "suggestion-quarantine__categories"
};
const _hoisted_7 = ["id", "name", "value"];
const _hoisted_8 = ["for"];
const _hoisted_9 = {
    key: 1,
    class: "suggestion-quarantine__categories--loading"
};
const _hoisted_10 = {
    key: 2,
    class: "suggestion-quarantine__frequency"
};
const _hoisted_11 = ["innerHTML"];
import { reactive, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { getActionCategoryList } from '@/services/actions';
import InfoCard from '@/components/_atoms/InfoCard.vue';
var CategoryListTechnicalTypes;
(function (CategoryListTechnicalTypes) {
    CategoryListTechnicalTypes["TIME_SENSITIVE"] = "SENS\u00CDVEIS AO TEMPO";
    CategoryListTechnicalTypes["RECURRING"] = "RECORRENTES";
})(CategoryListTechnicalTypes || (CategoryListTechnicalTypes = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignsManagementDetailsQuarantine',
    setup(__props) {
        const state = reactive({
            categories: [],
            selectedCategory: null,
            loading: false,
            hasError: false,
            emptyCategories: false,
        });
        const store = useStore();
        const getSuggestionDetail = computed(() => store.getters['campaignsManagement/getSuggestionDetail']);
        const getLoadingAction = computed(() => store.getters['campaignsManagement/getLoadingAction']);
        const getMode = computed(() => store.getters['campaignsManagement/getMode']);
        const getIsEmptyCategoryTooltipVisible = computed(() => store.getters['campaignsManagement/getIsEmptyCategoryTooltipVisible']);
        const getTypeCategory = computed(() => {
            const selectedCategory = state.categories.find(category => category.categoryID === state.selectedCategory);
            return selectedCategory ? selectedCategory.description : '-';
        });
        const typeFrequency = computed(() => {
            const selectedCategoryObj = state.categories.find(category => category.categoryID === state.selectedCategory);
            if (!selectedCategoryObj)
                return 'default';
            switch (selectedCategoryObj.technicalType) {
                case CategoryListTechnicalTypes.TIME_SENSITIVE:
                    return 'time-sensitive';
                case CategoryListTechnicalTypes.RECURRING:
                    return 'recurring';
                default:
                    return 'default';
            }
        });
        const getCategoryList = async () => {
            state.loading = true;
            getActionCategoryList()
                .then(response => {
                const categories = response?.data;
                if (!categories?.success || !categories?.data?.length) {
                    state.hasError = !categories?.success;
                    state.emptyCategories = !categories?.data?.length;
                    return;
                }
                const reorderedCategories = reorderCategories(categories.data);
                store.dispatch('campaignsManagement/setActionCategoryList', reorderedCategories);
                state.categories = reorderedCategories;
            })
                .finally(() => {
                state.loading = false;
            });
        };
        const reorderCategories = (categories) => {
            const midPoint = Math.ceil(categories.length / 2);
            const firstColumn = categories.slice(0, midPoint);
            const secondColumn = categories.slice(midPoint);
            const reorderedCategories = [];
            for (let index = 0; index < midPoint; index++) {
                if (firstColumn[index])
                    reorderedCategories.push(firstColumn[index]);
                if (secondColumn[index])
                    reorderedCategories.push(secondColumn[index]);
            }
            return reorderedCategories;
        };
        const updateCategory = (newValue) => {
            store.commit('campaignsManagement/SET_SELECTED_CATEGORY', newValue);
        };
        onMounted(() => {
            getCategoryList();
            if (getMode.value === 'edit') {
                store.dispatch('campaignsManagement/setStatusTooltip', {
                    key: 'actionCategory',
                    value: !getSuggestionDetail.value.actionCategory,
                });
            }
        });
        watch(() => state.selectedCategory, newValue => {
            updateCategory(newValue);
        });
        watch(() => getSuggestionDetail.value.actionCategory, newCategory => {
            if (newCategory && state.selectedCategory !== newCategory) {
                state.selectedCategory = newCategory;
                updateCategory(state.selectedCategory);
            }
            store.dispatch('campaignsManagement/setStatusTooltip', { key: 'actionCategory', value: !newCategory });
        });
        return (_ctx, _cache) => {
            const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
            const _component_el_skeleton = _resolveComponent("el-skeleton");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('settings.metrics.quarantine.suggestions.title')), 1),
                    _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createTextVNode("*")
                    ])), [
                        [
                            _directive_tooltip,
                            {
                                theme: 'error',
                                html: true,
                                autoHide: false,
                                distance: 8,
                                content: _ctx.$t('campaigns.required-section'),
                                shown: getIsEmptyCategoryTooltipVisible.value && !state.selectedCategory && !getLoadingAction.value,
                            },
                            void 0,
                            { right: true }
                        ]
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", {
                        innerHTML: _ctx.$t('settings.metrics.quarantine.suggestions.text')
                    }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", null, [
                    (state.categories.length && !state.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.categories, (category) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: category.categoryID
                                }, [
                                    _withDirectives(_createElementVNode("input", {
                                        required: "",
                                        type: "radio",
                                        id: 'category-' + category.categoryID,
                                        name: 'category-' + category.categoryID,
                                        value: category.categoryID,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((state.selectedCategory) = $event))
                                    }, null, 8, _hoisted_7), [
                                        [_vModelRadio, state.selectedCategory]
                                    ]),
                                    _createElementVNode("label", {
                                        for: 'category-' + category.categoryID
                                    }, _toDisplayString(category.description), 9, _hoisted_8)
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    (state.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_el_skeleton, {
                                loading: true,
                                animated: ""
                            }, {
                                template: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6], (index) => {
                                        return _createVNode(_component_el_skeleton_item, {
                                            variant: "p",
                                            key: index,
                                            style: { "margin-top": "12px" }
                                        });
                                    }), 64))
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_el_skeleton, {
                                loading: true,
                                animated: ""
                            }, {
                                template: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6], (index) => {
                                        return _createVNode(_component_el_skeleton_item, {
                                            variant: "p",
                                            key: index,
                                            style: { "margin-top": "12px" }
                                        });
                                    }), 64))
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    (!state.hasError && !state.emptyCategories)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (state.categories.length && !state.loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('global-quarantine-by-phone')), 1),
                                    _createElementVNode("p", {
                                        innerHTML: typeFrequency.value === 'default'
                                            ? _ctx.$t('settings.metrics.quarantine.suggestions.frequency.default')
                                            : _ctx.$t(`settings.metrics.quarantine.suggestions.frequency.${typeFrequency.value}`, {
                                                category: getTypeCategory.value,
                                            })
                                    }, null, 8, _hoisted_11)
                                ], 64))
                                : _createCommentVNode("", true),
                            (state.loading)
                                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                                    key: 1,
                                    loading: true,
                                    animated: ""
                                }, {
                                    template: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2], (index) => {
                                            return _createVNode(_component_el_skeleton_item, {
                                                variant: "p",
                                                key: index,
                                                style: { "margin-top": "12px" }
                                            });
                                        }), 64))
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (!state.loading && !state.categories.length)
                    ? (_openBlock(), _createBlock(InfoCard, {
                        key: 0,
                        ref: "message-error",
                        error: state.hasError && !state.loading
                    }, null, 8, ["error"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
